import { useState } from 'react';

export function useForceUpdate() {
    const [value, setter] = useState(0);
    return () => setter(value + 1);
}
